import React, { useEffect, useRef, useState } from 'react'
import { Box } from '@mui/material'
import { useIsResponsive } from '@/hooks'
import { EmtTypography, EmtModal, EmtButton } from 'emt-components-v2'
import ServiceContentSection from './ServiceContentForm'
import { useSignUpCallRequestStore } from '@/store/signUpCallRequestStore'

interface EditServiceModalProps {
  open: boolean
  setOpen: (open: boolean) => void
}

const EditServiceModal: React.FC<EditServiceModalProps> = ({ open, setOpen }) => {
  const [isMobile] = useIsResponsive()
  const serviceSectionRef = useRef<HTMLDivElement | null>(null)
  const setDistance = useSignUpCallRequestStore((s) => s.setDistance)
  const setService = useSignUpCallRequestStore((s) => s.setService)
  const service = useSignUpCallRequestStore((s) => s.service)
  const [loading, setLoading] = useState(false)
  const formRefs = useRef<Record<string, any>>({})
  const serviceContentRef = useRef<any>(null)
  const [selectedService, setSelectedService] = useState<string | null>(service?.selectedService || null)

  const handleValidate = async () => {
    setLoading(true)
    if (serviceContentRef.current && serviceContentRef.current.validate) {
      const valid = await serviceContentRef.current.validate()
      if (!valid) {
        setLoading(false)
        return
      }
    }
    const values = serviceContentRef.current.getValues()
    setService({ selectedService: values.selectedService, formSlots: values.formSlots })
    setDistance(values.distance)
    setOpen(false)
    setLoading(false)
  }

  useEffect(() => {
    setSelectedService(service?.selectedService || null)
  }, [service])

  return (
    <EmtModal
      open={open}
      disableScrollLock
      onClose={(event: React.MouseEvent) => {
        event.stopPropagation()
        setSelectedService(service?.selectedService || null)
        setOpen(false)
      }}
      sx={{
        '& .inner-box': { width: '800px', maxWidth: '90vw' },
        '& .children-box': { padding: isMobile ? '26px' : '40px' },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '20px',
        }}
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation()
        }}
      >
        <EmtTypography variant="h4" fontWeight={800}>
          Modifier le service
        </EmtTypography>
        {selectedService && service && (
          <ServiceContentSection
            ref={serviceContentRef}
            isMobile={isMobile}
            selectedService={selectedService}
            formRefs={formRefs}
            localStorageInitialValues={service || null}
            onServiceChange={setSelectedService}
            serviceSectionRef={serviceSectionRef}
          />
        )}
        <Box sx={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
          <EmtButton
            fullWidth
            variant="outlined"
            size="medium"
            color="purple"
            onClick={() => {
              setSelectedService(service?.selectedService || null)
              setOpen(false)
            }}
          >
            Annuler
          </EmtButton>
          <EmtButton fullWidth size="medium" color="purple" onClick={handleValidate} loader={loading}>
            Valider
          </EmtButton>
        </Box>
      </Box>
    </EmtModal>
  )
}

export default EditServiceModal
